import { Component, Injector, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mq_List } from '../mq_list/mq_list';
import { MSteps } from '../msteps/msteps';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { ClockComponent } from '../component/clock';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */ 

@Component({
  selector: 'page-mj_statistiche_sfida',
  templateUrl: 'mj_statistiche_sfida.html',  
})
export class Mj_Statistiche_Sfida extends Util {
  pagine: any;
  user: any;
  mj: any;
  fasi: any;
  items: any = [];
  sfida:any;
  //itemExpandHeight = 150;
  itemExpandHeight = [];
  mqs: any = [];
  statistiche:any = {grafici:[],lista:[]};
  stat: any = { mystat:{},avversariostat: {} };
  constructor(public navCtrl: NavController, public navParams: NavParams, injector: Injector, loading: LoadingController,clock: ClockComponent,public translate:TranslateService) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.mj = this.navParams.get('mj');
    this.sfida = this.navParams.get('sfida');
    //console.log('---mj:',this.user);
    this.refreshpage(this.sfida);

  }
  ngOnInit(): void {
    //console.log(this.navCtrl.getViews());
  }
  refreshpage(sfida) {
    if(sfida['statisticheSfidante']['Utente_id'] == this.user.id)
      {
        this.stat.mystat = sfida['statisticheSfidante'];
        this.stat.avversariostat = sfida['statisticheSfidato'];
      }
    else{
      this.stat.mystat = sfida['statisticheSfidato'];
      this.stat.avversariostat = sfida['statisticheSfidante']; 
    }
  }

  open_quest(m) {
    this.navCtrl.push(Mq_List, { mq_list: m });
  }
  // open_fase(m, i) {

  //   if(m.stato == 'IN_ATTESA'){
  //     this.showBasicAlert('Fase in Attesa','Non puoi accedere a questa fase');
  //     return;
  //   }

  //   this.GetRequest('microQuestFase', m.id,false,false).then(data => {

  //     //this.mqs = data['MicroQuestList'];

  //     this.fasi.map((listItem, index) => {

  //       if (m == listItem) {
  //         listItem.expanded = !listItem.expanded;
  //         this.mqs[index] = data['MicroQuestList'];
  //         // //console.log(50 * data['MicroQuestList'].length+1);
  //         this.itemExpandHeight[i] = 150 * data['MicroQuestList'].length+1;
  //       } else {
  //         listItem.expanded = false;
  //       }

  //       return listItem;

  //     });

  //   }).catch((e) => {
  //     console.error(e)
  //   })
  // }

  expandItem(item) {

    this.items.map((listItem) => {

      if (item == listItem) {
        listItem.expanded = !listItem.expanded;
      } else {
        listItem.expanded = false;
      }

      return listItem;

    });

  }
  // open_questionario(m,h) {
  //   if(m.attivo == false)
  //   {
  //     this.showBasicAlert('Alert','Questionario non attivo');
  //     return;
  //   }
  //   this.presentPopover(event, Confirm, 'Sei sicuro di voler iniziare ?',h+1).then((data) => {
  //     //console.log(data);
  //     if (data == 'confirm')
  //       this.navCtrl.push(MSteps, { mq: m ,mj:this.mj});
  //   });

  // }
  back(){
    this.navCtrl.pop({animate:false});
  }
  go_root(){
    this.navCtrl.setRoot(Dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/pages/mj_statistiche_sfida/mj_statistiche_sfida.ts